export default "__VITE_ASSET__D4QfceA0__"